export default "__VITE_ASSET__Brw3Vi5w__"